import { CheckRounded, ChevronLeftRounded } from '@mui/icons-material'
import { useIsAuth } from 'feature/auth/hooks'
import {
  OrderStepContent,
  OrderStepLayout,
} from 'feature/productOrder/CreateOrder/OrderStepLayout'
import { ProductOrderFooter } from 'feature/productOrder/CreateOrder/ProductOrderFooter'
import { ProductOrderHeader } from 'feature/productOrder/CreateOrder/ProductOrderHeader'
import { useState } from 'react'
import { Loading } from 'router/Loading'
import { useAppSelector } from 'store/hooks'

import { useDealerCodeCheck } from '../hooks/useDealerCodeCheck'
import { useUserDataForm } from '../hooks/useUserDataForm'
import { OrderDateDealerCode } from '../orderStepDate/OrderDateDealerCode'
import { StepComponentProps } from '../types/StepComponentProps'

import { ConfirmAddressBlock } from './confirmAddressBlock'
import { ConfirmBankDetailsBlock } from './confirmBankDetailsBlock'
import { ConfirmUserDataForm } from './confirmUserDataForm'
import style from './OrderStepConfirm.module.scss'
import { OrderStepConfirmProducts } from './orderStepConfirmProducts'
import { FormInputCheckbox } from 'feature/formComponents'
import classNames from 'classnames'

// последний шаг
// подтверждение данных + личные данные по заявке
export function OrderStepConfirm({
  completeStep,
  handlePrevious,
}: StepComponentProps) {
  const [isSubmitLoading, setSubmitLoading] = useState(false)
  const [isBlockUserDataFormVisible, setBlockUserDataFormVisible] =
    useState(false)

  const currentEditForm = useAppSelector(
    state => state.orderForm.currentEditForm,
  )
  const products = useAppSelector(
    state => state.orderForm.forms[currentEditForm].products,
  )
  const address = useAppSelector(
    state => state.orderForm.forms[currentEditForm].address,
  )

  const isAuth = useIsAuth()
  const clientType = useAppSelector(state => state.auth.authInfo.clientType)
  const userType = useAppSelector(
    state => state.orderForm.forms[currentEditForm].userType,
  )
  const isCompany =
    (isAuth && clientType === 'company') || userType === 'company'

  const { isDealerValid, dealerCodeProps } = useDealerCodeCheck()
  const userDataForm = useUserDataForm()

  const handleCompleteStep = () => {
    setSubmitLoading(true)
    completeStep(true)
  }

  const handlePreviousStep = () => handlePrevious(false)

  const handleUserDataFormVisibilityChange = () => {
    setBlockUserDataFormVisible(prevValue => !prevValue)

    if (isBlockUserDataFormVisible) {
      userDataForm.setEmailValue('')
      userDataForm.setPhoneValue('')
    }
  }

  if (userDataForm.isLoading) return <Loading />

  return (
    <OrderStepLayout>
      <ProductOrderHeader
        step={isCompany ? 'Шаг 5' : 'Шаг 4'}
        title='Подтверждение'
        description='Проверьте информацию о заказе'
      />
      <OrderStepContent>
        <div className={style.content}>
          <div className={style.form}>
            <div className={style.productsList}>
              {products.map(product => (
                <OrderStepConfirmProducts product={product} key={product.id} />
              ))}
            </div>

            <div className={style.informationBlock}>
              <ConfirmAddressBlock
                address={address?.address}
                geoLat={address?.geoLat}
                geoLon={address?.geoLon}
              />
              {isCompany && <ConfirmBankDetailsBlock />}
              <OrderDateDealerCode
                setButtonDisabled={() => {}}
                {...dealerCodeProps}
              />
            </div>
          </div>

          <div className={style.confirmUserDataBlock}>
            <FormInputCheckbox
              name='isConfirmUserDataBlockVisible'
              label='Заказ будет получать другой человек'
              checkboxProps={{
                onChange: handleUserDataFormVisibilityChange,
                checked: isBlockUserDataFormVisible,
              }}
            />

            <div
              className={classNames(style.confirmUserDataValue, {
                [style.visible]: isBlockUserDataFormVisible,
              })}
            >
              <ConfirmUserDataForm {...userDataForm} />
            </div>
          </div>
        </div>
      </OrderStepContent>
      <ProductOrderFooter
        nextButton={{
          onClick: handleCompleteStep,
          Icon: <CheckRounded />,
          text: 'Сохранить',
          disabled: !userDataForm.isValid || isSubmitLoading || !isDealerValid,
          isLoading: isSubmitLoading,
        }}
        prevButton={{
          onClick: handlePreviousStep,
          Icon: <ChevronLeftRounded />,
          text: 'Предыдущий шаг',
        }}
      />
    </OrderStepLayout>
  )
}
